import { Box, Typography } from '@mui/material'
import { colors } from '../../const/colors'

const EmptyState = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode
  title: string
  description: string
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      py: '64px',
      gap: '16px',
    }}
  >
    <Box
      sx={{
        width: 72,
        height: 72,
        borderRadius: '22px',
        background: colors.bg,
        border: `1.5px solid ${colors.border3}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: '4px',
      }}
    >
      {icon}
    </Box>
    <Box>
      <Typography
        sx={{ fontSize: '18px', fontWeight: 800, color: colors.navy, mb: '8px' }}
      >
        {title}
      </Typography>
      <Typography
        sx={{ fontSize: '14px', color: colors.slate, lineHeight: 1.65, maxWidth: 380 }}
      >
        {description}
      </Typography>
    </Box>
  </Box>
)

export default EmptyState
